import axiosInstance from "./baseUrl";

export const getAllCountry = async () => {
  const response = await axiosInstance.get("/v1/country/get_all_country");
  return response.data;
};

export const getStates = async (countryId: string) => {
  const response = await axiosInstance.get(`/v1/country/${countryId}/states`, {
    params: { countryId },
  });
  return response.data;
};

export const getCities = async (countryId: string, stateId: string) => {
  const response = await axiosInstance.get(
    `/v1/country/${countryId}/states/${stateId}/cities`
  );
  return response.data;
};

export const getAllLanguages = async () => {
  const response = await axiosInstance.get("/v1/country/get_all_languages");
  return response.data;
};
